import { useQuery } from '@tanstack/react-query';
import { getStudentFinance } from '../services/studentService';

export const useStudentFinance = (studentId) => {
  return useQuery({
    queryKey: ['studentFinance', studentId],
    queryFn: () => getStudentFinance(studentId).then(r => r.data),
    staleTime: 30000, // 30 seconds
    enabled: !!studentId,
    refetchOnWindowFocus: false,
  });
};
